export function isNumber(string) {
    let number = Number(string);
    return !isNaN(number);
}
